
const testimonials = [
  {
    content: "AnySkill helped me turn my graphic design hobby into a real business. I've gained entrepreneurial experience while earning money for college and building connections with students from other schools.",
    name: "Sarah K.",
    role: "High School Junior",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=100"
  },
  {
    content: "I found an amazing high school student through AnySkill who provides math tutoring. The platform creates incredible opportunities for students while offering affordable services to the community.",
    name: "Michael R.",
    role: "Parent",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=100"
  },
  {
    content: "AnySkill has transformed our school culture. Students are developing valuable skills, supporting each other, and creating a vibrant community of young entrepreneurs and innovators.",
    name: "Dr. Williams",
    role: "High School Principal",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=100"
  }
];

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-poppins font-bold text-3xl md:text-4xl mb-4 text-foreground">What Our Community Says</h2>
          <p className="font-inter text-muted-foreground max-w-2xl mx-auto">
            AnySkill is creating entrepreneurial opportunities for students while strengthening school communities.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-card rounded-xl p-8 shadow-md">
              <div className="mb-6">
                <svg className="h-8 w-8 text-anyskill-purple opacity-50" fill="currentColor" viewBox="0 0 32 32">
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
              </div>
              <p className="font-inter text-card-foreground/80 mb-6">{testimonial.content}</p>
              <div className="flex items-center">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name} 
                  className="w-12 h-12 rounded-full mr-4 object-cover"
                  loading="lazy"
                  width="48"
                  height="48"
                />
                <div>
                  <h3 className="font-poppins font-semibold text-card-foreground">{testimonial.name}</h3>
                  <p className="font-inter text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
